import axios from "../../plugins/axios";
import utils from "../../../utils/utils";

// 主数据模块api
class Material {

    //----------物料主数据相关--------------------//
    //INTF-00001：获取分页的物料主数据列表。
    async getMaterialMainList(val) {
        let body = val;
        try {
            let res = await axios.post(`/myMaterialApp/service.MaterialProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.material_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get material list in pages failed: INTF-00001", err);
            return { err: true, msg: err.response.data };
        }

    }

    //INTF-00002：保存新建的物料主数据
    addMaterial(val) {
        let body = val
        return axios.post(`/myMaterialApp/service.MaterialProvider/CreateOne`, body);
    }

    //INTF-00003：批量生失效物料主数据
    batchMaterialEnableOrDisable(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post("/myMaterialApp/service.MaterialProvider/UpdateActived", body);
    }

    //INTF-00015：修改物料主数据的信息
    modifyMaterial(body) {
        return axios.post("/myMaterialApp/service.MaterialProvider/UpdateDetails", body);
    }

    //INTF-00016：删除选中的物料主数据
    batchDeleteMaterial(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myMaterialApp/service.MaterialProvider/Delete`, body);
    }

    //INTF-00130：批量发布物料基本视图
    batchReleaseMaterial(arr) {
        let body = { id_arr: arr, if_released: 3 };
        return axios.post(`/myMaterialApp/service.MaterialProvider/Release`, body);
    }


    //INTF-00295：根据请求的物料ID，获得其详情信息
    getMaterialBaseViewById(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.MaterialProvider/FindOne`, body);
    }

    //-------------------物料采购视图------------------------//
    //INTF-00017：获取物料的分页的采购视图列表
    async getPurchaseViewList(mid, query) {
        let body = { material_id: mid, query: query };
        try {
            let res = await axios.post(`/myMaterialApp/service.PurchaseProvider/FindAllByMaterial`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.purchase_view_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get purchase view list in page by material id failed: INTF-00017", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00125：对新建的采购视图进行保存
    addMaterialPurchaseView(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.PurchaseProvider/CreateOne`, body);
    }

    //INTF-00131：更新一个物料的采购视图
    modifyPurchaseView(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.PurchaseProvider/UpdateDetails`, body);
    }


    //INTF-00137：批量设置采购视图的生失效
    batchPurchaseViewEnableOrDisable(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myMaterialApp/service.PurchaseProvider/UpdateActived`, body);
    }


    //INTF-00299：根据ID获取采购视图详细信息
    async getPurchaseViewDetailById(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myMaterialApp/service.PurchaseProvider/FindById`, body);
            //检查判断其中的一些价格字段，如果是undefined，就补0
            res.unit_price = res.unit_price === undefined ? 0 : res.unit_price;
            res.estimated_price = res.estimated_price === undefined ? 0 : res.estimated_price;
            res.package_fee = res.package_fee === undefined ? 0 : res.package_fee;
            res.transportation_fee = res.transportation_fee === undefined ? 0 : res.transportation_fee;
            res.allocate_price_a = res.allocate_price_a === undefined ? 0 : res.allocate_price_a;
            res.allocate_qty_a = res.allocate_qty_a === undefined ? 0 : res.allocate_qty_a;
            res.allocate_unit_price_a = res.allocate_unit_price_a === undefined ? 0 : res.allocate_unit_price_a;
            res.allocate_price_b = res.allocate_price_b === undefined ? 0 : res.allocate_price_b;
            res.allocate_qty_b = res.allocate_qty_b === undefined ? 0 : res.allocate_qty_b;
            res.allocate_unit_price_b = res.allocate_unit_price_b === undefined ? 0 : res.allocate_unit_price_b;
            res.allocate_price_c = res.allocate_price_c === undefined ? 0 : res.allocate_price_c;
            res.allocate_qty_c = res.allocate_qty_c === undefined ? 0 : res.allocate_qty_c;
            //这里unit多了一个e，故意的，将错就错
            res.allocate_unite_price_c = res.allocate_unite_price_c === undefined ? 0 : res.allocate_unite_price_c;
            return res;
        } catch (err) {
            console.log("get purchase view detail failed: INTF-00299", err);
            return { err: true, msg: err.response.data };
        }
    }


    //INTF-00300：删除选中的采购视图
    batchPurchaseViewDelete(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myMaterialApp/service.PurchaseProvider/Delete`, body);
    }

    //INTF-00387：获取某个用户创建的所有物料的有效且草稿状态的采购视图
    async getAllMaterialDraftPurchaseView(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.PurchaseProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.purchase_view_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get pv list in pages failed: INTF-00387", err);
            return { err: true, msg: err.response.data };
        }
    }


    //----------------物料销售视图----------------------//

    //INTF-00019：获取分页的销售视图列表
    async getSaleViewList(mid, query) {
        let body = { material_id: mid, query: query };
        try {
            let res = await axios.post(`/myMaterialApp/service.SalesViewProvider/FindAllByMaterial`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.sale_view_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get sale view list in pages failed: INTF-00019", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00126：对新建的销售视图进行保存
    addMaterialSaleView(body) {
        return axios.post(`/myMaterialApp/service.SalesViewProvider/CreateOne`, body);
    }


    //INTF-00133：更新一个物料的销售视图
    modifySaleView(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.SalesViewProvider/UpdateDetails`, body);
    }


    //INTF-00139：批量设置销售视图的生失效
    batchSaleViewEnableOrDisable(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myMaterialApp/service.SalesViewProvider/UpdateActived`, body);
    }

    //INTF-00294：删除选中的销售视图
    batchSaleViewDelete(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myMaterialApp/service.SalesViewProvider/Delete`, body);
    }

    //INTF-00298：根据ID获取销售视图详细信息
    getSaleViewDetailById(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.SalesViewProvider/FindById`, body);
    }

    //INTF-00531：分页查询所有物料的所有销售视图列表
    async getAllMaterialSaleView(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.SalesViewProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.sale_view_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get material sale views in pages failed: INTF-00531", err);
            return { err: true, msg: err.response.data };
        }
    }

    //--------------------------物流视图-----------------------------------------//
    //INTF-00018：根据物料ID，查询返回对应物流视图列表
    async getLogisticViewList(mid, query) {
        let body = { material_id: mid, query: query };
        try {
            let res = await axios.post(`/myMaterialApp/service.LogisticsProvider/FindAllByMaterial`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.logistics_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get logistic view list in pages by material id failed: INTF-00018", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00127：对新建的物流视图进行保存
    addMaterialLogisticView(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.LogisticsProvider/CreateOne`, body);
    }

    //INTF-00132：对修改的物流视图进行保存
    modifyLogisticView(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.LogisticsProvider/UpdateDetails`, body);
    }

    //INTF-00138：批量设置物流视图的生失效
    batchLogisticViewEnableOrDisable(arr, x, route) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myMaterialApp/service.LogisticsProvider/UpdateActived`, body);
    }

    //INTF-00328：根据物流视图ID，返回物流视图的详情信息
    getLogisticViewDetailById(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.LogisticsProvider/FindById`, body);
    }

    //INTF-00332：批量删除选中的草稿物流视图
    batchLogisticViewDelete(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myMaterialApp/service.LogisticsProvider/Delete`, body);
    }

    //INTF-00333：根据物料id,工厂id，{material_id, factory_id}，获取当前有效的物流视图
    async getLogisticViewByFactoryAndMaterialWithId(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.LogisticsProvider/FindOne`, body);
            if (res.logistics_infos === undefined) {
                //没有符合条件的有效物流视图，补全对象
                res.logistics_infos = {};
            }
            return res;
        } catch (err) {
            console.log("get logistic view by factory adn material failed: INTF-00333", err);
            return { err: true, msg: err.response.data };
        }
    }

    //---------------------------物料的配额视图相关------------------------------------------------//
    //INTF-00306：在一个物料下，创建一个配额规则头
    addQuotaHeader(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.QuotaHeaderProvider/CreateOne`, body);
    }

    //INTF-00307：获取一个物料下的配额规则头
    async getQuotaHeaderList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.QuotaHeaderProvider/FindAllByMaterial`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.quota_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get quota header list in pages failed: INTF-00307", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00308：删除草稿的配额规则头
    batchDeleteQuotaHeaders(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myMaterialApp/service.QuotaHeaderProvider/Delete`, body);
    }

    //INTF-00309：保存修改的配额规则头
    updateQuotaHeader(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.QuotaHeaderProvider/UpdateDetails`, body);
    }

    //INTF-00310：保存创建或修改的配额规则的列表
    updateQuotaList(arr, id) {
        let body = { quota_line_infos: arr, quota_header_id: id };
        return axios.post(`/myMaterialApp/service.QuotaLineProvider/UpdateSome`, body);
    }

    //INTF-00313：获取不分页的配额规则列表
    async getQuotaListById(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myMaterialApp/service.QuotaLineProvider/FindByHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.quota_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get quota lis by id in pages failed: iNTF-00313", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00315：根据一个配额规则头id，获取其详细信息
    getQuotaHeaderDetailById(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.QuotaHeaderProvider/FindById`, body);
    }

    //INTF-00322：提供物料ID，设置该物料的配额是否启用
    enableOrDisableQuota(id, x) {
        let body = { id: id, if_quota: x };
        return axios.post(`/myMaterialApp/service.MaterialProvider/UpdateQuota`, body);
    }

    //INTF-00413：发布一个配额规则头
    releaseQuotaHeader(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.QuotaHeaderProvider/Release`, body);
    }

    //INTF-00414：批量设置配额规则头的生失效
    batchEnableOrDisableQuotaHeaders(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myMaterialApp/service.QuotaHeaderProvider/UpdateActived`, body);
    }



    //--------计量单位相关------------//
    //INTF-00020：不分页的，获取有效可用的计量单位
    async getUomListInOnePage() {
        let body = {};
        try {
            let res = await axios.post(`/myBasicDataApp/service.uom.UomProvider/FindAllWithoutLimit`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.uom_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get uom list in no page failed: INTF-00020", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00023：分页显示所有的计量单位列表
    async getUomList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myBasicDataApp/service.uom.UomProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.uom_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get uom list in pages failed: INTF-00023", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00024：对新建的计量单位进行保存
    addUom(body) {
        return axios.post(`/myBasicDataApp/service.uom.UomProvider/CreateOne`, body);
    }

    //INTF-00034：对已有的计量单位进行修改保存
    updateUom(body) {
        return axios.post(`/myBasicDataApp/service.uom.UomProvider/UpdateDetails`, body);
    }

    //INTF-00037：删除选中的计量单位
    batchUomDelete(body) {
        return axios.post(`/myBasicDataApp/service.uom.UomProvider/Delete`, body);
    }

    //INTF-00150：计量单位的生效/失效操作
    batchUomEnableOrDisable(body) {
        return axios.post(`/myBasicDataApp/service.uom.UomProvider/UpdateActived`, body);
    }


    //---------------------------物料的BOM视图相关--------------------------------------------//
    //--------------------------------BOM数据头相关----------------------------------//
    //INTF-00290：基于一个物料，在其下创建BOM数据头
    addBomHeaderByMaterial(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.MaterialBOMHeaderProvider/CreateOne`, body);
    }

    //INTF-00291：批量删除一个物料下的BOM数据头
    batchDeleteBomHeaders(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myMaterialApp/service.MaterialBOMHeaderProvider/Delete`, body);
    }

    //INTF-00292：修改一个BOM数据头
    updateBomHeader(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.MaterialBOMHeaderProvider/UpdateDetails`, body);
    }

    //INTF-00293：分页获取物料下的BOM数据头列表
    async getBomHeaderListByMaterial(mid, query) {
        let body = { material_id: mid, query: query };
        try {
            let res = await axios.post(`/myMaterialApp/service.MaterialBOMHeaderProvider/FindAllByMaterial`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.bom_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get bom header list in pages failed: INTF-00293", err);
            return { err: true, msg: err.response.data };
        }
    }


    //INTF-00389：获取一个BOM数据头的详细信息
    getBomHeaderDetailById(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.MaterialBOMHeaderProvider/FindById`, body);
    }

    //INTF-00393：批量禁用或启用BOM数据头
    batchEnableOrDisableBomHeaders(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myMaterialApp/service.MaterialBOMHeaderProvider/UpdateActived`, body);
    }

    //--------------------------------BOM数据的行相关-----------------------------------//
    //INTF-00388：获取一个BOM数据头下的BOM行明细
    async getBomLineByHeader(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.MaterialBOMLineProvider/FindAllByHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.bom_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get bom line by header in pages failed: INTF-00388", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00390：对新建的一条BOM行进行保存
    addBomLine(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.MaterialBOMLineProvider/CreateOne`, body);
    }

    //INTF-00391：对修改的一条BOM行进行保存
    updateBomLine(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.MaterialBOMLineProvider/UpdateDetails`, body);
    }

    //INTF-00392：在BOM数据头下，删除一条BOM行
    batchDeleteBomLines(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myMaterialApp/service.MaterialBOMLineProvider/Delete`, body);
    }

    //---------------------------------物料分组相关------------------------------//
    //INTF-00541：分页查询获取物料分组列表
    async getMaterialGroupList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.MaterialGroupProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.group_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get material group list in pages failed: INTF-00541", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00542：对新建的分组头进行保存
    addMaterialGroupHeader(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.MaterialGroupProvider/CreateOne`, body);
    }

    //INTF-00543：根据id，获取分组头详情信息
    getMaterialGroupHeaderDetail(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.MaterialGroupProvider/FindById`, body);
    }

    //INTF-00544：批量删除草稿的分组
    batchDeleteMaterialGroup(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myMaterialApp/service.MaterialGroupProvider/Delete`, body);
    }

    //INTF-00545：对修改的分组头信息进行保存
    updateMaterialGroupHeader(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.MaterialGroupProvider/UpdateDetails`, body);
    }

    //---------------------------分组头下的明细行-----------------------//
    //INTF-00546：在分组头下，批量添加多条物料明细行
    batchAddLinesInMaterialGroupHeader(arr, route) {
        let body = { types: "object,object", values: [{ idArr: arr }, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }

    //INTF-00547：在分组头下，批量移除物料明细行
    batchRemoveLinesInMaterialGroupHeader(arr, route) {
        let body = { types: "object,object", values: [{ idArr: arr }, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }

    //INTF-00548：在分组头下，分页查询获取物料明细行
    getLinesInMaterialGroupHeader(query, route) {
        let body = { types: "object,object", values: [query, utils.getUidAndToken(route)] };
        return axios.post(`/myMaterialApp/service.MaterialGroupProvider/GroupQuery`, body);
    }

    //---------------------物料成本维护----------------------------//
    //INTF-00678：对一个新建的物料成本进行保存
    addCostInfoInMaterial(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.FinancialProvider/CreateOne`, body);
    }

    //INTF-00679：对修改的物料成本信息进行修改保存
    updateCostInfoInMaterial(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.FinancialProvider/UpdateDetails`, body);
    }

    //INTF-00680：对选中的草稿进行批量删除
    batchDeleteCostInfosInMaterial(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myMaterialApp/service.FinancialProvider/Delete`, body);
    }

    //INTF-00681：批量设置生失效
    batchEnableOrDisableCostInfoInMaterial(arr, x, route) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myMaterialApp/service.FinancialProvider/UpdateActived`, body);
    }

    //INTF-00682：分页查询获取物料下的成本信息
    async getCostListInMaterialInpage(mid, query) {
        let body = { material_id: mid, query: query };
        try {
            let res = await axios.post(`/myMaterialApp/service.FinancialProvider/FindAllByMaterial`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.financial_view_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get cost list in material in pages failed: INTF-00682", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00792：根据用户请求内容，导出需要的视图内容
    getMaterialViewListDownloadInfo(query) {
        let body = query;
        return axios.post(`/myMaterialApp/service.MaterialProvider/ExportViews`, body);
    }


}
export default Material;